export const routesWithHiddenForm: (typeof window.currentRoute)[] = [
    'meet_the_team',
    'gb_front_mobile_referral_page',
]